import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';

export const SwiperContainer = styled.div<{ hideControls?: boolean }>`
    width: 100%;

    ${({ hideControls }) => hideControls && css`
        .slider .slider-control-centerleft,
        .slider .slider-control-centerright,
        .slider .slider-control-bottomcenter {
            display: none !important;
        }
    `}

    .slider .slider-control-centerleft {
        top: -13px !important;
        right: 52px !important;
        left: auto !important;

        @media (max-width: ${wideBreakpoints.mobile}) {
            right: 0px !important;
        }
    }

    .slider .slider-control-centerright {
        top: -13px !important;
        right: 0 !important;
        width: 40px;

        > div {
            justify-content: flex-end;
        }
    }

    .slider .slider-control-bottomcenter {
        position: relative !important;
    }
`;

export const CustomSwiper = styled(NukaCarousel)<{ isLoading?: boolean }>`
    padding-left: 0 !important;
    padding-right: 0 !important;

    & section,
    & div {
        outline: none;
    }

    & div.slider-frame {
        ${({ isLoading }) => isLoading
            ? css`
                height: 435px !important;
                padding: 0 !important;
                margin: 24px  0 !important;
            `
            : css`
                padding: 24px 0 !important;

                @media (max-width: ${wideBreakpoints.sMobile}) {
                    padding: 22px 0 !important;
                }
            `
        }
    }

    & div.slider-slide {
        height: 410px !important;

        @media (max-width: ${wideBreakpoints.mobile}) {
            height: 399px !important;
        }
    }
`;
